import { compose } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import {
    getLandingPageDetailVisitsAsync,
    getLandingPageReportsAsync,
    getLandingPageVisitsAsync,
} from "../../../../redux/slices/landingReports/landingReports.asyncActions";
import {
    clearLandingPageReports,
    landingPageReportsReducer,
} from "../../../../redux/slices/landingReports/landingReports.slice";
import {
    getLandingPageDetailVisitsAsyncPayload,
    getLandingPageReportsAsyncPayload,
    getLandingPageVisitsAsyncPayload,
} from "../../../../redux/slices/landingReports/landingReports.types";
import LandingPageReportsPage from "./LandingPageReportsPage.layout";
import {
    LandingPageReportsPageDispatchProps,
    LandingPageReportsPageStateProps,
} from "./LandingPageReportsPage.types";

const mapStateToProps = (state: any): LandingPageReportsPageStateProps => ({
    isReportsLoading: state[landingPageReportsReducer]?.isReportsLoading,
    landingPageReports: state[landingPageReportsReducer]?.landingPageReports,
    isVisitsLoading: state[landingPageReportsReducer]?.isVisitsLoading,
    landingPageVisits: state[landingPageReportsReducer]?.landingPageVisits,
    isDetailLoading: state[landingPageReportsReducer]?.isDetailLoading,
    landingPageDetailVisits:
        state[landingPageReportsReducer]?.landingPageDetailVisits,
    language: state.languagesState?.languages,
});

const mapDispatchToProps = (
    dispatch: any,
): LandingPageReportsPageDispatchProps => ({
    dispatchGetLandingPageReports: (
        params: getLandingPageReportsAsyncPayload,
    ) => dispatch(getLandingPageReportsAsync(params)),
    dispatchGetLandingPageVisits: (params: getLandingPageVisitsAsyncPayload) =>
        dispatch(getLandingPageVisitsAsync(params)),
    dispatchGetLandingPageDetailVisits: (
        params: getLandingPageDetailVisitsAsyncPayload,
    ) => dispatch(getLandingPageDetailVisitsAsync(params)),
    dispatchClearLandingPageReports: () => dispatch(clearLandingPageReports()),
});

const decorate = compose(connect(mapStateToProps, mapDispatchToProps));

export default decorate(LandingPageReportsPage);
